/*
 * @Description: bus
 * @Author: wangwangwang
 * @Date: 2020-07-10 16:19:01
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-07-10 16:19:08
 */ 
import Vue from 'vue'
export default new Vue()
